import { Component, OnInit, OnDestroy, ViewChild, Input, HostListener ,AfterContentInit, ElementRef } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit, OnDestroy, AfterContentInit {

  userSubscription: Subscription = new Subscription();

  public registerFG: UntypedFormGroup;
  hide = true;
  userImg: any;
  imgExt = "";
  userCv: any;
  userSign: any;
  espec = [];
  userId = 0;
  timeZones = [];
  public profile: any;
  @Input() name: string;
  @ViewChild('sigPad') sigPad: ElementRef;
  sigPadElement;
  isDrawing = false;
  context;
  img = './assets/sinfirma.jpg';

  constructor(private _formBuilder: UntypedFormBuilder, private store: Store<AppState>, private service: AuthService) { }

  ngAfterContentInit(){
    setTimeout(() => {
      this.sigPadElement = this.sigPad.nativeElement;
      this.context = this.sigPadElement.getContext('2d');
      this.context.strokeStyle = "#3742fa";
    },1000);
  }

  ngOnInit() {

    //this.service.getTimeZones().subscribe( (d:String[]) =>{
    //  this.timeZones = d;
    //})

    /*this.sigPadElement = this.sigPad.nativeElement;
    this.context = this.sigPadElement.getContext('2d');
    this.context.strokeStyle = "#3742fa";*/

    this.timeZones = ["Africa/Abidjan","Africa/Accra","Africa/Algiers","Africa/Bissau","Africa/Cairo","Africa/Casablanca","Africa/Ceuta","Africa/El_Aaiun","Africa/Johannesburg","Africa/Juba","Africa/Khartoum","Africa/Lagos","Africa/Maputo","Africa/Monrovia","Africa/Nairobi","Africa/Ndjamena","Africa/Sao_Tome","Africa/Tripoli","Africa/Tunis","Africa/Windhoek","America/Adak","America/Anchorage","America/Araguaina","America/Argentina/Buenos_Aires","America/Argentina/Catamarca","America/Argentina/Cordoba","America/Argentina/Jujuy","America/Argentina/La_Rioja","America/Argentina/Mendoza","America/Argentina/Rio_Gallegos","America/Argentina/Salta","America/Argentina/San_Juan","America/Argentina/San_Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Asuncion","America/Atikokan","America/Bahia","America/Bahia_Banderas","America/Barbados","America/Belem","America/Belize","America/Blanc-Sablon","America/Boa_Vista","America/Bogota","America/Boise","America/Cambridge_Bay","America/Campo_Grande","America/Cancun","America/Caracas","America/Cayenne","America/Chicago","America/Chihuahua","America/Costa_Rica","America/Creston","America/Cuiaba","America/Curacao","America/Danmarkshavn","America/Dawson","America/Dawson_Creek","America/Denver","America/Detroit","America/Edmonton","America/Eirunepe","America/El_Salvador","America/Fort_Nelson","America/Fortaleza","America/Glace_Bay","America/Goose_Bay","America/Grand_Turk","America/Guatemala","America/Guayaquil","America/Guyana","America/Halifax","America/Havana","America/Hermosillo","America/Indiana/Indianapolis","America/Indiana/Knox","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Tell_City","America/Indiana/Vevay","America/Indiana/Vincennes","America/Indiana/Winamac","America/Inuvik","America/Iqaluit","America/Jamaica","America/Juneau","America/Kentucky/Louisville","America/Kentucky/Monticello","America/La_Paz","America/Lima","America/Los_Angeles","America/Maceio","America/Managua","America/Manaus","America/Martinique","America/Matamoros","America/Mazatlan","America/Menominee","America/Merida","America/Metlakatla","America/Mexico_City","America/Miquelon","America/Moncton","America/Monterrey","America/Montevideo","America/Nassau","America/New_York","America/Nipigon","America/Nome","America/Noronha","America/North_Dakota/Beulah","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/Nuuk","America/Ojinaga","America/Panama","America/Pangnirtung","America/Paramaribo","America/Phoenix","America/Port-au-Prince","America/Port_of_Spain","America/Porto_Velho","America/Puerto_Rico","America/Punta_Arenas","America/Rainy_River","America/Rankin_Inlet","America/Recife","America/Regina","America/Resolute","America/Rio_Branco","America/Santarem","America/Santiago","America/Santo_Domingo","America/Sao_Paulo","America/Scoresbysund","America/Sitka","America/St_Johns","America/Swift_Current","America/Tegucigalpa","America/Thule","America/Thunder_Bay","America/Tijuana","America/Toronto","America/Vancouver","America/Whitehorse","America/Winnipeg","America/Yakutat","America/Yellowknife","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Macquarie","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","Asia/Almaty","Asia/Amman","Asia/Anadyr","Asia/Aqtau","Asia/Aqtobe","Asia/Ashgabat","Asia/Atyrau","Asia/Baghdad","Asia/Baku","Asia/Bangkok","Asia/Barnaul","Asia/Beirut","Asia/Bishkek","Asia/Brunei","Asia/Chita","Asia/Choibalsan","Asia/Colombo","Asia/Damascus","Asia/Dhaka","Asia/Dili","Asia/Dubai","Asia/Dushanbe","Asia/Famagusta","Asia/Gaza","Asia/Hebron","Asia/Ho_Chi_Minh","Asia/Hong_Kong","Asia/Hovd","Asia/Irkutsk","Asia/Jakarta","Asia/Jayapura","Asia/Jerusalem","Asia/Kabul","Asia/Kamchatka","Asia/Karachi","Asia/Kathmandu","Asia/Khandyga","Asia/Kolkata","Asia/Krasnoyarsk","Asia/Kuala_Lumpur","Asia/Kuching","Asia/Macau","Asia/Magadan","Asia/Makassar","Asia/Manila","Asia/Nicosia","Asia/Novokuznetsk","Asia/Novosibirsk","Asia/Omsk","Asia/Oral","Asia/Pontianak","Asia/Pyongyang","Asia/Qatar","Asia/Qostanay","Asia/Qyzylorda","Asia/Riyadh","Asia/Sakhalin","Asia/Samarkand","Asia/Seoul","Asia/Shanghai","Asia/Singapore","Asia/Srednekolymsk","Asia/Taipei","Asia/Tashkent","Asia/Tbilisi","Asia/Tehran","Asia/Thimphu","Asia/Tokyo","Asia/Tomsk","Asia/Ulaanbaatar","Asia/Urumqi","Asia/Ust-Nera","Asia/Vladivostok","Asia/Yakutsk","Asia/Yangon","Asia/Yekaterinburg","Asia/Yerevan","Atlantic/Azores","Atlantic/Bermuda","Atlantic/Canary","Atlantic/Cape_Verde","Atlantic/Faroe","Atlantic/Madeira","Atlantic/Reykjavik","Atlantic/South_Georgia","Atlantic/Stanley","Australia/Adelaide","Australia/Brisbane","Australia/Broken_Hill","Australia/Darwin","Australia/Eucla","Australia/Hobart","Australia/Lindeman","Australia/Lord_Howe","Australia/Melbourne","Australia/Perth","Australia/Sydney","CET","CST6CDT","EET","EST","EST5EDT","Etc/GMT","Etc/GMT+1","Etc/GMT+10","Etc/GMT+11","Etc/GMT+12","Etc/GMT+2","Etc/GMT+3","Etc/GMT+4","Etc/GMT+5","Etc/GMT+6","Etc/GMT+7","Etc/GMT+8","Etc/GMT+9","Etc/GMT-1","Etc/GMT-10","Etc/GMT-11","Etc/GMT-12","Etc/GMT-13","Etc/GMT-14","Etc/GMT-2","Etc/GMT-3","Etc/GMT-4","Etc/GMT-5","Etc/GMT-6","Etc/GMT-7","Etc/GMT-8","Etc/GMT-9","Etc/UTC","Europe/Amsterdam","Europe/Andorra","Europe/Astrakhan","Europe/Athens","Europe/Belgrade","Europe/Berlin","Europe/Brussels","Europe/Bucharest","Europe/Budapest","Europe/Chisinau","Europe/Copenhagen","Europe/Dublin","Europe/Gibraltar","Europe/Helsinki","Europe/Istanbul","Europe/Kaliningrad","Europe/Kiev","Europe/Kirov","Europe/Lisbon","Europe/London","Europe/Luxembourg","Europe/Madrid","Europe/Malta","Europe/Minsk","Europe/Monaco","Europe/Moscow","Europe/Oslo","Europe/Paris","Europe/Prague","Europe/Riga","Europe/Rome","Europe/Samara","Europe/Saratov","Europe/Simferopol","Europe/Sofia","Europe/Stockholm","Europe/Tallinn","Europe/Tirane","Europe/Ulyanovsk","Europe/Uzhgorod","Europe/Vienna","Europe/Vilnius","Europe/Volgograd","Europe/Warsaw","Europe/Zaporozhye","Europe/Zurich","HST","Indian/Chagos","Indian/Christmas","Indian/Cocos","Indian/Kerguelen","Indian/Mahe","Indian/Maldives","Indian/Mauritius","Indian/Reunion","MET","MST","MST7MDT","PST8PDT","Pacific/Apia","Pacific/Auckland","Pacific/Bougainville","Pacific/Chatham","Pacific/Chuuk","Pacific/Easter","Pacific/Efate","Pacific/Enderbury","Pacific/Fakaofo","Pacific/Fiji","Pacific/Funafuti","Pacific/Galapagos","Pacific/Gambier","Pacific/Guadalcanal","Pacific/Guam","Pacific/Honolulu","Pacific/Kiritimati","Pacific/Kosrae","Pacific/Kwajalein","Pacific/Majuro","Pacific/Marquesas","Pacific/Nauru","Pacific/Niue","Pacific/Norfolk","Pacific/Noumea","Pacific/Pago_Pago","Pacific/Palau","Pacific/Pitcairn","Pacific/Pohnpei","Pacific/Port_Moresby","Pacific/Rarotonga","Pacific/Tahiti","Pacific/Tarawa","Pacific/Tongatapu","Pacific/Wake","Pacific/Wallis","WET"];

    const doctorDataFromLocalStorage = JSON.parse(localStorage.getItem('mindhelp_doctor'));
  
    console.log(doctorDataFromLocalStorage)

    this.registerFG = this._formBuilder.group({
      first_name: [doctorDataFromLocalStorage.first_name, Validators.required],
      last_name: [doctorDataFromLocalStorage.last_name, Validators.required],
      email: [{ value:doctorDataFromLocalStorage.email, disabled: true },],
      description: [doctorDataFromLocalStorage.user_description, Validators.required],
      country_code: ['+52', Validators.required],
      phone_number: [doctorDataFromLocalStorage.phone, Validators.required],
      country: [doctorDataFromLocalStorage.country, Validators.required],
      date_of_birth: [{ value: doctorDataFromLocalStorage.birth_at, disabled: true }],
      gender: [doctorDataFromLocalStorage.gender, Validators.required],
      time_zone: [doctorDataFromLocalStorage.time_zone, Validators.required],
      speciality: [[],Validators.required],
      working_since: [doctorDataFromLocalStorage.working_since,Validators.required]
    });
    this.getSpecialities();
    this.getInformation();
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e){
    this.isDrawing = false;
  }

  getSpecialities(){
    this.service.getSpecialities().subscribe( (d: any) =>{
      console.log(d)
      let decData = JSON.parse(this.service.decrypt(d.message));
      this.espec = decData.data.items;
    });
  }

  getInformation(){
    this.userSubscription = this.store.select('user').subscribe(data => {
      let user = data.data;
      this.userId = user.id;
      this.service.getProfile(user.id).subscribe((d: any) => {
        let decData = JSON.parse(this.service.decrypt(d.message,"private"));
        this.profile = decData.data.items[0];
        console.log(this.profile);
        this.userImg = this.profile.photo_media_id ? this.profile.photo_media_id.url : "https://via.placeholder.com/300.png/09f/fff" ;
        this.img = this.profile.sign_media_id ? this.profile.sign_media_id.url : './assets/sinfirma.jpg';
        document.getElementById("imgTag").setAttribute("src", this.userImg);
        this.setInformation();
      });
    });
  }

  setInformation(){
    let date = new Date(this.profile.birth_at);
    let idServices = this.profile.services.map( elem =>{return elem.id});
    this.registerFG.setValue({
      first_name: this.profile.first_name,
      last_name: this.profile.last_name,
      email: this.profile.email,
      description: this.profile.user_description,
      country_code: '+52',
      phone_number: this.profile.phone,
      country: this.profile.country,
      date_of_birth: `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`,
      gender: this.profile.gender,
      time_zone: this.profile.time_zone,
      speciality: idServices,
      working_since: new Date(this.profile.working_since),
    });
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  clickFile(id) {
    document.getElementById(id).click();
  }

  getFile(event) {
    let file = event.target.files[0];
    if(file.size > 1048576){
      alert("El tamaño del archivo excede de 1MB");
      return;
    }
    this.imgExt = file.name.split(".")[1];
    let reader = new FileReader();
    reader.onload = this.fileOnload.bind(this);
    reader.readAsDataURL(file);
  }

  fileOnload(e) {
    let result = e.target.result;
    this.userImg = result.split(",")[1];
    document.getElementById("imgTag").setAttribute("src", result)
  }

  getFileCv(event) {
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.onload = this.fileOnloadCv.bind(this);
    reader.readAsDataURL(file);
  }

  fileOnloadCv(e) {
    let result = e.target.result;
    this.userCv = {
      base64: result.split(",")[1],
      base64_extension: "pdf"
    }

    this.service.uploadCv(this.userCv, this.userId).subscribe(d => {
      console.log(d)
      Swal.fire({
        icon: 'success',
        title: 'Bien!',
        text: "Su CV se ha envido",
      })
    }, err => {
      Swal.fire({
        icon: 'error',
        title: 'Algo ha salido mal',
        text: "Su CV no se ha podido cargar",
      })
    })

  }

  uploadSign() {
    if(this.img == "") return;
    let result = this.img.split(',');
    if(result.length != 2) return;
    this.userSign = {
      base64: result[1],
      base64_extension: "png"
    }

    this.service.uploadSing(this.userSign).subscribe(d => {
      console.log(d)
      Swal.fire({
        icon: 'success',
        title: 'Bien!',
        text: "Su firma fue guardada",
      })
    }, err => {
      Swal.fire({
        icon: 'error',
        title: 'Algo ha salido mal',
        text: "La firma no se pudo guardar",
      })
    })

  }

  saveForm() {
    let user = {
      "first_name": (this.registerFG.value.first_name),
      "working_since": new Date(this.registerFG.value.working_since).getTime(),
      "last_name": (this.registerFG.value.last_name),
      "country_code": (this.registerFG.value.country_code),
      "phone": (this.registerFG.value.phone_number),
      "country": (this.registerFG.value.country),
      "gender": (this.registerFG.value.gender),
      "services": (this.registerFG.value.speciality),
      "time_zone": (this.registerFG.value.time_zone),//"America/Mexico_City",
      "user_description": this.registerFG.value.description,
      "base64": this.userImg,
      "base64_extension": this.imgExt
    }

    if(this.imgExt == ""){
      delete user.base64; delete user.base64_extension;
    }

    this.profile.services.forEach(service => {
      if(!user.services.find(ser => ser == service.id)){
        this.service.deleteService(this.userId, service.id).subscribe(d => console.log(d));
      }else{
        user.services.splice(user.services.indexOf(service.id),1);
      }
    });

    user.services.forEach(element => {
        this.service.setServices(this.userId, element).subscribe(d => console.log(d));
    });

    this.service.editProfile(user, this.userId).subscribe(data => {
      Swal.fire({
        icon: 'success',
        title: 'Listo',
        text: "Perfil modificado",
      });
    });

    this.getInformation();
  }

  onMouseDown(e){
    if(!this.context) return;
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e){
    if(!this.context) return;
    if(this.isDrawing){
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  private relativeCoords(event){
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return {x:x, y:y};
  }

  limpiar(){
    if(!this.context) return;
    this.context.clearRect(0,0,this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
  }

  guardar(){
    this.img = this.sigPadElement.toDataURL("image/png");
    console.log(this.img);
    this.uploadSign();
  }

}
